const classes = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
    justifyContent: 'flex-end',
  },
  counterpartChip: {
    backgroundColor: 'primary.main',
    color: 'secondary.main',
    fontWeight: 600,
    fontSize: 12,
  },
  sourceChip: {
    backgroundColor: 'common.lightBackgroundColor',
    color: 'primary.main',
    fontWeight: 600,
  },
};

export default classes;
